import { Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';

export const DataSourceValueField = ({
  columnIndex,
  field,
  control,
}: PropertyGridFieldProps) => {
  const { fieldName, toDisplayValue } = field;

  const propertyDataFieldName: FieldPath<PropertyGridForm> = `columns.${columnIndex}.propertyData.${fieldName}`;
  const value = useWatch({ control, name: propertyDataFieldName }) as string | undefined;
  const displayValue = toDisplayValue ? toDisplayValue(value) : value;

  return <Typography {...readOnlyFieldTypographyProps}>{displayValue}</Typography>;
};
